import { render } from "./JoinGameView.vue?vue&type=template&id=955f410e"
import script from "./JoinGameView.vue?vue&type=script&lang=js"
export * from "./JoinGameView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__